var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
var Popover_1 = __importDefault(require("./Popover"));
exports.Popover = Popover_1.default;
exports.default = Popover_1.default;
//# sourceMappingURL=index.js.map